<template>
  <div class="page full">
    <div id="public-web-container" class="hidden">
      <p class="">正在打开 “拉勾”...</p>
      <!-- replace -->
      <a
        id="public-web-jump-button"
        href="javascript:"
        class="weui-btn weui-btn_primary weui-btn_loading"
        @click="openWeapp"
      >
        <span
          id="public-web-jump-button-loading"
          class="weui-primary-loading weui-primary-loading_transparent"
          ><i class="weui-primary-loading__dot"></i
        ></span>
        打开小程序
      </a>
    </div>
    <div id="wechat-web-container" class="hidden">
      <p class="">点击以下按钮打开 “拉勾”</p>
      <!-- replace -->
      <!-- 跳转小程序的开放标签。文档 https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_Open_Tag.html -->
      <wx-open-launch-weapp
        id="launch-btn"
        username="gh_5bc6c955d1db"
        path="/pages/card/index"
      >
        <!-- replace -->
        <template>
          <button
            style="
              width: 200px;
              height: 45px;
              text-align: center;
              font-size: 17px;
              display: block;
              margin: 0 auto;
              padding: 8px 24px;
              border: none;
              border-radius: 4px;
              background-color: #07c160;
              color: #fff;
            "
          >
            打开小程序
          </button>
        </template>
      </wx-open-launch-weapp>
    </div>
    <div id="desktop-web-container" class="hidden">
      <p class="">请在手机打开网页链接</p>
    </div>
  </div>
</template>

<script>
import * as Cookies from "js-cookie";
export default {
  data() {
    return {
        id: 1
    };
  },
  created() {
      this.id = this.$route.query.id || 1;
  },
  mounted() {
    this.$nextTick(() => {
        this.docReadyFn()
    })
  },
    methods: {
        docReadyFn() {
            this.docReady(async () => {
                var ua = navigator.userAgent.toLowerCase();
                var isWXWork = ua.match(/wxwork/i) == "wxwork";
                var isWeixin =
                    !isWXWork && ua.match(/micromessenger/i) == "micromessenger";
                var isMobile = false;
                var isDesktop = false;
                if (
                    navigator.userAgent.match(
                    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i
                    )
                ) {
                    isMobile = true;
                } else {
                    isDesktop = true;
                }

                if (isWeixin) {
                    var containerEl = document.getElementById("wechat-web-container");
                    containerEl.classList.remove("hidden");
                    containerEl.classList.add("full", "wechat-web-container");

                    var launchBtn = document.getElementById("launch-btn");
                    launchBtn.addEventListener("ready", function (e) {
                    console.log("开放标签 ready");
                    });
                    launchBtn.addEventListener("launch", function (e) {
                    console.log("开放标签 success");
                    });
                    launchBtn.addEventListener("error", function (e) {
                    console.log("开放标签 fail", e.detail);
                    });

                    wx.config({
                    // debug: true, // 调试时可开启
                    appId: "wx02500360786d6343", // <!-- replace -->
                    timestamp: 0, // 必填，填任意数字即可
                    nonceStr: "nonceStr", // 必填，填任意非空字符串即可
                    signature: "signature", // 必填，填任意非空字符串即可
                    jsApiList: ["chooseImage"], // 必填，随意一个接口即可
                    openTagList: ["wx-open-launch-weapp"], // 填入打开小程序的开放标签名
                    });
                } else if (isDesktop) {
                    // 在 pc 上则给提示引导到手机端打开
                    var containerEl = document.getElementById("desktop-web-container");
                    containerEl.classList.remove("hidden");
                    containerEl.classList.add("full", "desktop-web-container");
                } else {
                    var containerEl = document.getElementById("public-web-container");
                    containerEl.classList.remove("hidden");
                    containerEl.classList.add("full", "public-web-container");
                    var c = new cloud.Cloud({
                    // 必填，表示是未登录模式
                    identityless: true,
                    // 资源方 AppID
                    resourceAppid: "wx02500360786d6343", // <!-- replace -->
                    // 资源方环境 ID
                    resourceEnv: "cloud1-0gnl6naeeebc6e91", // <!-- replace -->
                    });
                    await c.init();
                    window.c = c;

                    var buttonEl = document.getElementById("public-web-jump-button");
                    var buttonLoadingEl = document.getElementById(
                    "public-web-jump-button-loading"
                    );
                    try {
                    await this.openWeapp(() => {
                        buttonEl.classList.remove("weui-btn_loading");
                        buttonLoadingEl.classList.add("hidden");
                    });
                    } catch (e) {
                        buttonEl.classList.remove("weui-btn_loading");
                        buttonLoadingEl.classList.add("hidden");
                    throw e;
                    }
                }
                });
        },
        docReady(fn) {
        if (
            document.readyState === "complete" ||
            document.readyState === "interactive"
        ) {
            fn();
        } else {
            document.addEventListener("DOMContentLoaded", fn);
        }
        },
        async openWeapp(onBeforeJump) {
          console.log(this.type)
            var c = window.c;
            const res = await c.callFunction({
                name: "public",
                data: {
                    action: "getUrlScheme",
                    id: this.id
                },
            });
            console.warn(res.result.openlink);
            if (typeof onBeforeJump == 'function') {
                onBeforeJump();
            } else {
                this.onBeforeJumpFn();
            }
            location.href = res.result.openlink;
        },
        onBeforeJumpFn() {
            var buttonEl = document.getElementById("public-web-jump-button");
            var buttonLoadingEl = document.getElementById("public-web-jump-button-loading");
            buttonEl.classList.remove("weui-btn_loading");
            buttonLoadingEl.classList.add("hidden");

        }
    }
};
</script>

<style lang="less" scoped>
.container {
  position: relative;
  width: 100%;
  overflow-y: auto;
  padding-bottom: 184px;
}
</style>
<style>
.hidden {
  display: none;
}

.full {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.public-web-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.public-web-container p {
  position: absolute;
  top: 40%;
}

.public-web-container a {
  position: absolute;
  bottom: 40%;
}

.wechat-web-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.wechat-web-container p {
  position: absolute;
  top: 40%;
}

.wechat-web-container wx-open-launch-weapp {
  position: absolute;
  bottom: 40%;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.desktop-web-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.desktop-web-container p {
  position: absolute;
  top: 40%;
}
</style>
